import { TAppValidator } from "../../../application/types";

const STUDENT_ERROR_MESSAGE = "Student is required";

export const validator: TAppValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};
  const stepName = "chooseStudent";

  if (!values[stepName]?.student) {
    errors.student = STUDENT_ERROR_MESSAGE;

    throw {
      [stepName]: errors,
    };
  }

  if (Object.keys(errors).length > 0) {
    throw {
      [stepName]: errors,
    };
  }
};
